import React from "react";
import { Field, FieldProps } from "formik";
import styled from "styled-components";
import Icon from "../Icon/Icon";

interface ICheckboxProps {
  name: string;
  isError?: boolean;
}

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 5px;
  left: 4px;
  cursor: pointer;
`;

const StyledInput = styled.input<ICheckboxProps>`
  position: absolute;
  width: 20px;
  height: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 150ms;
  cursor: pointer;

  &:checked {
    background-color: ${({ theme }) => theme.accent.normal};
    border: 2px solid ${({ theme }) => theme.accent.normal};
  }

  &:focus {
    outline: none !important;
  }
`;

const CheckboxLabel = styled.label`
  display: inline-block;
  position: relative;
  top: 0;
  width: 20px;
  height: 20px;
`;

const FormCheckbox = ({ name, isError }: ICheckboxProps) => {
  return (
    <Field name={name} type="checkbox">
      {({ field }: FieldProps) => {
        return (
          <CheckboxLabel>
            <StyledInput {...field} type="checkbox" isError={isError} />
            {field.checked && <StyledIcon name="checkMark" size="20px" />}
          </CheckboxLabel>
        );
      }}
    </Field>
  );
};

export default FormCheckbox;
